<template>
    <picture class="def-picture">
        <source
            :srcset="loadImage ? result.desktop.src : getBasePreview(result.desktop)"
            media="(min-width: 992px)"
        >
        <source
            :srcset="loadImage ? result.tablet.src : getBasePreview(result.tablet)"
            media="(min-width: 768px)"
        >
        <img
            :srcset="loadImage ? result.mobile.src : getBasePreview(result.mobile)"
            :alt="result.mobile.alt"
            :width="result[ getDeviceName ].width"
            :height="result[ getDeviceName ].height"
            :style="imageStyle"
            class="def-picture__image"
        >
    </picture>
</template>

<script>
export default {
    name: 'DefPicture',
    selector: '.def-picture',
    props: {
        result: Object,
        maxWidth: String,
        maxHeight: String,
    },
    data() {
        return {
            intersectionObserver: null,
            options: {
                rootMargin: '100px',
                threshold: .01,
            },
            loadImage: false,
        }
    },
    computed: {
        imageStyle() {
            if (this.result?.height > this.result?.width) {
                return `max-height: ${ this.maxWidth ?? '100%' };`;
            } else {
                return `max-width: ${ this.maxHeight ?? '100%' };`;
            }
        },
        getDeviceName() {
            if (this.screenWidth >= 992) {
                return 'desktop';
            } else if (this.screenWidth >= 768) {
                return 'tablet';
            }
            return 'mobile';
        }
    },
    methods: {
        getBasePreview(picture) {
            let canvas = document.createElement('canvas');
            canvas.width = picture.width ?? 1;
            canvas.height = picture.height ?? 1;
            return canvas.toDataURL();
        },
        observerCallBack (entries) {
            // If intersectionRatio is 0, the target is out of view
            // and we do not need to do anything.
            // console.log(entries[0].intersectionRatio);
            if (entries[0].intersectionRatio <= 0) return;

            this.loadImage = true;
            this.intersectionObserver.unobserve(this.$el);
        }
    },
    mounted() {
        if (this.result) {
            if ('IntersectionObserver' in window) {
                // LazyLoad images using IntersectionObserver
                this.intersectionObserver = new IntersectionObserver(this.observerCallBack, this.options);
                this.intersectionObserver.observe(this.$el);
            }  else {
                // Load all images at once
                this.loadImage = true;
            }
        }
    },
    beforeUnmount() {
        if ('IntersectionObserver' in window) {
            this.intersectionObserver.unobserve(this.$el);
        }
    }
}
</script>

<style lang="scss" scoped>
.def-picture{
    &__image{
        display: block;
        height: auto;
        visibility: visible;
    }
}
</style>